import { clientConfig } from "../config";

/* Google tag manager TRACKER   */


const EVENTS = ["ViewThankyouPage", "cookie_consent_marketing","ga4_auto_event"];

const isUkPage = () => {
  const path = window.location.pathname.toLowerCase();
  return path.split("/").includes("uk") || path.split("/").includes("gb");
}

const loadArrivalVariables = ()=>{
  try{
    let trackingData = window.eventsTracking.getData();
    let lastArrival = trackingData.arrivals[trackingData.arrivals.length-1]

    let url

    // in case url starts only with ? -> in case of short arrival (iphone prevent localstorage cross subdomains)
    if (lastArrival.url.startsWith("?")){
      url = new URL("http://a.com" + lastArrival.url)
    }
    else{
      url = new URL(lastArrival.url)
    }

    let foundParams = false

    let dataLayerParams = {}

    url.searchParams.forEach((value,key)=>{
      foundParams = true
      dataLayerParams['ARRIVAL_PARAM_' + key.toUpperCase()] = value
    })

    if (foundParams){
      window.dataLayer.push(dataLayerParams);
    }

  }
  catch(err){
    window.clientLogger.error('error loading arrival Variables into GTM',err)
  }
}


// GTM is lazy loaded here and not in the main index.html because we need to set variables before it's loaded
export const init = () =>{
  window.dataLayer = window.dataLayer || [];
  // init the varaibles
  loadArrivalVariables();

  if (isUkPage() && clientConfig.GTM_ID_UK) {
    // UK: load directly from googletagmanager.com (matches CMS behavior)
    (function (w, d, s, l, i) {
      w[l] = w[l] || [];
      w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
      var f = d.getElementsByTagName(s)[0],
        j = d.createElement(s),
        dl = l != "dataLayer" ? "&l=" + l : "";
      j.async = true;
      j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
      f.parentNode.insertBefore(j, f);
    })
      (window, document, "script", "dataLayer", clientConfig.GTM_ID_UK);

    // noscript fallback (matches CMS <noscript> block for UK)
    var noscript = document.createElement('noscript');
    var iframe = document.createElement('iframe');
    iframe.src = 'https://www.googletagmanager.com/ns.html?id=' + clientConfig.GTM_ID_UK;
    iframe.height = '0';
    iframe.width = '0';
    iframe.style.display = 'none';
    iframe.style.visibility = 'hidden';
    noscript.appendChild(iframe);
    document.body.insertBefore(noscript, document.body.firstChild);
  } else {
    // All other countries: load via /metrics/ proxy
    (function (w, d, s, l, i) {
      w[l] = w[l] || [];
      w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
      var f = d.getElementsByTagName(s)[0],
        j = d.createElement(s),
        dl = l != "dataLayer" ? "&l=" + l : "";
      j.async = true;
      j.src = '/metrics/?id=' + i + dl;
      f.parentNode.insertBefore(j, f);
    })
      (window, document, "script", "dataLayer", clientConfig.GTM_ID);
  }

}

export const track = (eventType, eventName, data={}) => {

  if (eventType === "pv") {
    // do nothing
  } else { // eventType = "custom" goes here
    if (EVENTS.includes(eventName)) {
      // Auto-add category if subcategory exists
      let eventData = {event:eventName, ...data};
      window.dataLayer.push(eventData);
    } 
  }
};

